export const goApiRoutes = ["panel/advanced-automation"];

export const footerTags = {
  unsubscribe: "Unsubscribe",
  view_in_browser: "View this email in your browser",
  mailing_preference: "Mailing Preferences",
  report_abuse: "Report Abuse",
};

export const perPageCount = 10;
export const mailboxProviders = [
  { label: "g-suite", value: "g-suite" },
  {
    label: "microsoft-workspace",
    value: "microsoft-workspace",
  },
  { label: "yahoo-workspace", value: "yahoo-workspace" },
  { label: "zoho", value: "zoho" },
  { label: "zoho-workspace", value: "zoho-workspace" },
  {
    label: "protonmail-workspace",
    value: "protonmail-workspace",
  },
  { label: "protonmail", value: "protonmail" },
  { label: "gmx-workspace", value: "gmx-workspace" },
  { label: "gmx", value: "gmx" },
  { label: "yandex-workspace", value: "yandex-workspace" },
  { label: "yandex", value: "yandex" },
  { label: "icloud", value: "icloud" },
  { label: "icloud-workspace", value: "icloud-workspace" },
  {
    label: "hostgator-workspace",
    value: "hostgator-workspace",
  },
  { label: "mailbox.org", value: "mailbox.org" },
  { label: "bluehost-workspace", value: "bluehost-workspace" },
  {
    label: "dreamhost-workspace",
    value: "dreamhost-workspace",
  },
  {
    label: "intermedia-workspace",
    value: "intermedia-workspace",
  },
  { label: "1&1", value: "1&1" },
  {
    label: "rackspace-workspace",
    value: "rackspace-workspace",
  },
  { label: "icewarp-workspace", value: "icewarp-workspace" },
  {
    label: "hyperoffice-workspace",
    value: "hyperoffice-workspace",
  },
  { label: "mxroute-workspace", value: "mxroute-workspace" },
  {
    label: "rediffmail-workspace",
    value: "rediffmail-workspace",
  },
  {
    label: "rediffmail",
    value: "rediffmail",
  },
  {
    label: "startmail-workspace",
    value: "startmail-workspace",
  },
  { label: "one-workspace", value: "one-workspace" },
  { label: "mail.ru", value: "mail.ru" },
  { label: "hushmail", value: "hushmail" },
  { label: "posteo", value: "posteo" },
  { label: "runbox", value: "runbox" },
  { label: "mailfence", value: "mailfence" },
  { label: "lavabit", value: "lavabit" },
  { label: "lycos", value: "lycos" },
  { label: "bigpond", value: "bigpond" },
  { label: "netzero", value: "netzero" },
  { label: "juno", value: "juno" },
  { label: "tiscali", value: "tiscali" },
  { label: "virgin media", value: "virgin media" },
  { label: "sky", value: "sky" },
  { label: "bt", value: "bt" },
  { label: "talktalk", value: "talktalk" },
  { label: "naver", value: "naver" },
  { label: "daum", value: "daum" },
  { label: "163", value: "163" },
  { label: "126", value: "126" },
  { label: "sina", value: "sina" },
  { label: "yeah.net", value: "yeah.net" },
  { label: "sapo", value: "sapo" },
  { label: "terra", value: "terra" },
  { label: "seznam", value: "seznam" },
  { label: "orange", value: "orange" },
  { label: "t-online", value: "t-online" },
  { label: "libero", value: "libero" },
  { label: "web.de", value: "web.de" },
  { label: "xfinity", value: "xfinity" },
  { label: "shaw", value: "shaw" },
  { label: "bell", value: "bell" },
  { label: "rogers", value: "rogers" },
  { label: "videotron", value: "videotron" },
  { label: "sympatico", value: "sympatico" },
  { label: "optonline", value: "optonline" },
  { label: "cox", value: "cox" },
  { label: "charter", value: "charter" },
  { label: "frontier", value: "frontier" },
  { label: "windstream", value: "windstream" },
  { label: "rcn", value: "rcn" },
  { label: "sbcglobal", value: "sbcglobal" },
  { label: "pacbell", value: "pacbell" },
  { label: "netscape", value: "netscape" },
  { label: "excite", value: "excite" },
  { label: "bluemail", value: "bluemail" },
  { label: "inbox.com", value: "inbox.com" },
  { label: "openmailbox", value: "openmailbox" },
  { label: "vfemail", value: "vfemail" },
  { label: "eclipso", value: "eclipso" },
  { label: "topmail.com", value: "topmail.com" },
  { label: "luxsci", value: "luxsci" },
  { label: "secure email", value: "secure email" },
  { label: "disroot", value: "disroot" },
  {
    label: "autistici/inventati",
    value: "autistici/inventati",
  },
  { label: "riseup", value: "riseup" },
  { label: "securemyemail", value: "securemyemail" },
  { label: "burner mail", value: "burner mail" },
  { label: "tutanota", value: "tutanota" },
  { label: "secure safe", value: "secure safe" },
  { label: "greatmail", value: "greatmail" },
  { label: "fasthosts", value: "fasthosts" },
  { label: "mail2world", value: "mail2world" },
  { label: "logix", value: "logix" },
  { label: "immenzaces", value: "immenzaces" },
  { label: "sophos", value: "sophos" },
  { label: "namebright", value: "namebright" },
  { label: "secureserver", value: "secureserver" },
  { label: "ppe-hosted", value: "ppe-hosted" },
  { label: "infomaniak", value: "infomaniak" },
  { label: "netease", value: "netease" },
  { label: "hostrelay", value: "hostrelay" },
  { label: "proofpoint", value: "proofpoint" },
  { label: "barracuda", value: "barracuda" },
  { label: "hostinger", value: "hostinger" },
  { label: "mimecast", value: "mimecast" },
  { label: "mxlogic", value: "mxlogic" },
  { label: "netcore", value: "netcore" },
  { label: "mailchimp", value: "mailchimp" },
  { label: "gmail", value: "gmail" },
  { label: "yahoo", value: "yahoo" },
  { label: "outlook", value: "outlook" },
  { label: "hotmail", value: "hotmail" },
  { label: "live", value: "live" },
  { label: "aol", value: "aol" },
  { label: "fastmail", value: "fastmail" },
  { label: "vivaldi", value: "vivaldi" },
  { label: "qq", value: "qq" },
  { label: "others", value: "others" },
];
